import { ArticleHeading2 } from '@cian/ui-kit';
import { useMemo } from 'react';
import { SellWithCian } from 'shared/landingSeller/components/SellWithCian';
import { useWithModalForm } from 'shared/common/hooks/useWithModalForm';

export const SellWithCianContainer: React.FC = () => {
  const { handleOpenModal, device } = useWithModalForm();

  const ItemTitle = useMemo(() => (device === 'desktop' ? ArticleHeading2 : ArticleHeading2), [device]);

  return <SellWithCian device={device} onOpenModal={handleOpenModal} ItemTitle={ItemTitle} />;
};
